// @https://codeorum.com/tutorials/simple-accordion-collapsible-element-with-vanilla-js-and-simple-animation-effect
// @https://codepen.io/codeorum/pen/JjGzMRQ

function initAccSingle(elem, option) {
	document.addEventListener("click", function (e) {
		if (!e.target.matches(elem + ' .product-accordion-title')) return;
		else {
			if (!e.target.parentElement.classList.contains("active")) {
				if (option == true) {
					var elementList = document.querySelectorAll(
						elem + ".product-accordion-container"
					);
					Array.prototype.forEach.call(elementList, function (e) {
						e.classList.remove("active");
					});
				}
				e.target.parentElement.classList.add("active");
			} else {
				e.target.parentElement.classList.remove("active");
			}
		}
	});
}

initAccSingle(".product-accordion", false);
